import { CountryList } from "client/lib/apt-merchant";

import { Field } from "../../field";
import { BusinessOwner } from "../../fieldsets";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { fileUploadS3TestValue } from "../../utils/constants";

import { determineGovIdApplicable } from "./GovIdField";

export const determineGovIdBacksideApplicable = (
  registeredCountry?: CountryList
): boolean => {
  if (registeredCountry === "United Kingdom") {
    return true;
  }
  if (registeredCountry === "Australia") {
    return true;
  }

  return false;
};

export class GovIdBacksideField extends Field<string> {
  protected readonly _owner: BusinessOwner;

  constructor(
    model: Merchant,
    owner: BusinessOwner,
    opts: Partial<MerchantField<string>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: fileUploadS3TestValue,
      propertyName: "govIdBackside",
      uiFieldType: "FileUpload",
      ...opts,
    });

    this._owner = owner;
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    // make sure the front govId is applicable before we show the back
    return (
      determineGovIdApplicable({
        registeredCountry,
      }) && determineGovIdBacksideApplicable(registeredCountry)
    );
  }

  get required(): boolean {
    const { requireId } = this._owner.controlValues;

    return this.applicable && requireId;
  }

  get shown(): boolean {
    return this.applicable;
  }

  get uploadFilename(): string {
    const firstName = this._owner.firstName.value;
    const lastName = this._owner.lastName.value;
    return `${firstName}_${lastName}_govIdBackside`;
  }
}
